
























































import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment-timezone';
import { KycRequests } from '@/api';
import { KycOrgConfig, GeneralDoc, OptionalDocs } from '@/api/auth';
import IdDocType from '@/resources/enum/IdDocType';
import MnDocType from '@/resources/enum/MnDocType';
import ApiCancelError from '@/resources/error/ApiCancelError';
import ApiModalError from '@/resources/error/ApiModalError';
import PageHeader from '@/components/PageHeader.vue';
import TopFooterButton from '@/components/TopFooterButton.vue';
import TopContentTitle from '@/components/TopContentTitle.vue';
import TopContentText from '@/components/TopContentText.vue';
import TopContentSelect from '@/components/TopContentSelect.vue';
import TopContentSelectGpDoc from '@/components/TopContentSelectGpDoc.vue';
import TopContentSelectOpDoc from '@/components/TopContentSelectOpDoc.vue';
import TopContentInformation from '@/components/TopContentInformation.vue';
import TopContentCautionList from '@/components/TopContentCautionList.vue';
import TopContentCautionContactUs from '@/components/TopContentCautionContactUs.vue';
import TopContentCheck from '@/components/TopContentCheck.vue';
import { PersonalInformation as PersonalInformationApi } from '@/api';

@Component({
  components: {
    TopContentCautionContactUs,
    PageHeader,
    TopFooterButton,
    TopContentTitle,
    TopContentText,
    TopContentSelect,
    TopContentSelectGpDoc,
    TopContentSelectOpDoc,
    TopContentInformation,
    TopContentCautionList,
    TopContentCheck
  }
})
export default class PersonalInformation extends Vue {
  private isFirstLoading: boolean = false;
  private isLastLoading: boolean = false;
  private isChecked: boolean = false;
  private idDocTypeId: IdDocType = IdDocType.Unknown;
  private mnDocTypeId: MnDocType = MnDocType.Unknown;
  private gpDocTypeId: string = 'unknown';
  private opDocTypeId: string[] = [];
  private firstName: string = '';
  private middleName: string = '';
  private lastName: string = '';
  private birthDay: string = '';
  private zipCode: string = '';
  private maskedAddress1: string = '';
  private maskedAddress2: string = '';
  private maskedAddress3: string = '';
  private maskedAddress4: string = '';

  // ボタン有効確認
  private get enabled(): boolean {
    return this.isChecked;
  }

  private get isIddocList(): boolean {
    if (this.selectGpDocList.length > 0 && this.$store.getters['auth/isOnlyGpGeneral']) return false;
    return true;
  }

  private get isMndocList(): boolean {
    if (this.selectGpDocList.length > 0 && this.$store.getters['auth/isOnlyGpGeneral']) return false;
    return this.selectMnDocList.length > 0;
  }

  private get isGpdocList(): boolean {
    return this.selectGpDocList.length > 0;
  }

  private get isOpdocList(): boolean {
    if (this.selectGpDocList.length > 0 && this.$store.getters['auth/isOnlyGpGeneral']) return false;
    return this.selectOpDocList.length > 0;
  }

  private get fullName(): string[] {
    let fullname: string = '';
    if (this.$i18n.locale !== 'ja') {
      fullname = `${this.lastName} ${this.firstName} ${this.middleName}`;
    } else {
      fullname = `${this.lastName} ${this.middleName} ${this.firstName}`;
    }
    return [fullname.trim().replace(/ +/g, '\u3000')];
  }

  private get formattedBirthDay(): string[] {
    return [
      moment(this.birthDay)
        .tz('Asia/Tokyo')
        .format(this.$tc('topPersonalInformation.format'))
    ];
  }

  private get fullAddress(): string[] {
    return [this.maskedAddress1 + this.maskedAddress2 + this.maskedAddress3 + this.maskedAddress4];
  }

  private get orgName(): string {
    return this.$store.getters['auth/currentLanguageOrgName'];
  }

  private get checkKYCRequestInformation(): boolean {
    const kycOrgConfig: KycOrgConfig = this.$store.getters['auth/kycOrgConfig'];
    return kycOrgConfig.checkKYCRequestInformation;
  }

  private get headerBar(): string {
    if (this.checkKYCRequestInformation) {
      return this.$t('topPersonalInformation.headerCheck') as string;
    } else if (this.selectGpDocList.length > 0) {
      return this.$t('topPersonalInformation.headerSelectGpdoc') as string;
    } else if (this.$store.getters['auth/isCollectMnDocOnly']) {
      return this.$t('topPersonalInformation.headerSelectMndoc') as string;
    } else {
      return this.$t('topPersonalInformation.headerSelectIddoc') as string;
    }
  }

  private get headerText(): string {
    if (this.checkKYCRequestInformation) {
      if (this.selectGpDocList.length > 0) {
        return this.$t('topPersonalInformation.descriptionCheckGpdoc') as string;
      } else if (this.$store.getters['auth/isCollectMnDocOnly']) {
        return this.$t('topPersonalInformation.descriptionCheckMndoc') as string;
      } else {
        return this.$t('topPersonalInformation.descriptionCheckIddoc') as string;
      }
    } else {
      if (this.selectGpDocList.length > 0) {
        return this.$t('topPersonalInformation.descriptionSelectGpdoc') as string;
      } else if (this.$store.getters['auth/isCollectMnDocOnly']) {
        return this.$t('topPersonalInformation.descriptionSelectMndoc') as string;
      } else {
        return this.$t('topPersonalInformation.descriptionSelectIddoc') as string;
      }
    }
  }

  private get informationList(): {
    label: string;
    values: string[];
  }[] {
    const checkName: string = this.$t('topPersonalInformation.checkName') as string;
    const checkBirth: string = this.$t('topPersonalInformation.checkBirth') as string;
    const checkAddress: string = this.$t('topPersonalInformation.checkAddress') as string;
    return [
      { label: checkName, values: this.fullName },
      { label: checkBirth, values: this.formattedBirthDay },
      { label: checkAddress, values: this.fullAddress }
    ];
  }

  private get cautionList(): string[] {
    if (this.checkKYCRequestInformation) {
      return [
        this.$t('topPersonalInformation.cautionSame') as string,
        this.$t('topPersonalInformation.cautionClose') as string,
        this.$t('topPersonalInformation.cautionTime') as string,
        this.$t('topPersonalInformation.cautionPermission') as string
      ];
    }

    return [
      this.$t('topPersonalInformation.cautionClose') as string,
      this.$t('topPersonalInformation.cautionTime') as string,
      this.$t('topPersonalInformation.cautionPermission') as string
    ];
  }

  private get checkText(): string {
    if (this.checkKYCRequestInformation) {
      return this.$t('topPersonalInformation.checkboxCheck') as string;
    }

    return this.$t('topPersonalInformation.checkboxSelect') as string;
  }

  private get selectIdDocList(): {
    key: IdDocType;
    text: string;
  }[] {
    let idDocTypes: IdDocType[] = this.$store.getters['auth/idDocTypes'];

    // 番号順に並べ替える
    idDocTypes = idDocTypes.sort((a, b) => a - b);

    // パスポートを最後に並べ替える
    [IdDocType.PassportHo, IdDocType.PassportTo, IdDocType.PassportTi].forEach((idDocType: IdDocType): void => {
      const index: number = idDocTypes.indexOf(idDocType);
      if (index < 0) return;
      idDocTypes.splice(index, 1);
      idDocTypes.push(idDocType);
    });

    const selectorTexts: { [key in IdDocType]: string } = {
      [IdDocType.DriversLicenseHo]: 'topPersonalInformation.selectIdentityDocumentDriversLicense',
      [IdDocType.DriversLicenseTo]: 'topPersonalInformation.selectIdentityDocumentDriversLicense',
      [IdDocType.DriversLicenseTi]: 'topPersonalInformation.selectIdentityDocumentDriversLicense',
      [IdDocType.MyNumberCardHo]: 'topPersonalInformation.selectIdentityDocumentMyNumberCard',
      [IdDocType.MyNumberCardTo]: 'topPersonalInformation.selectIdentityDocumentMyNumberCard',
      [IdDocType.MyNumberCardTi]: 'topPersonalInformation.selectIdentityDocumentMyNumberCard',
      [IdDocType.ResidenceCardHo]: 'topPersonalInformation.selectIdentityDocumentResidenceCard',
      [IdDocType.ResidenceCardTo]: 'topPersonalInformation.selectIdentityDocumentResidenceCard',
      [IdDocType.ResidenceCardTi]: 'topPersonalInformation.selectIdentityDocumentResidenceCard',
      [IdDocType.SpecialPermanentResidentCertificateHo]:
        'topPersonalInformation.selectIdentityDocumentSpecialPermanentResidentCertificate',
      [IdDocType.SpecialPermanentResidentCertificateTo]:
        'topPersonalInformation.selectIdentityDocumentSpecialPermanentResidentCertificate',
      [IdDocType.SpecialPermanentResidentCertificateTi]:
        'topPersonalInformation.selectIdentityDocumentSpecialPermanentResidentCertificate',
      [IdDocType.PassportHo]: 'topPersonalInformation.selectIdentityDocumentPassport',
      [IdDocType.PassportTo]: 'topPersonalInformation.selectIdentityDocumentPassport',
      [IdDocType.PassportTi]: 'topPersonalInformation.selectIdentityDocumentPassport',
      [IdDocType.DrivingHistoryCertificateHo]: 'topPersonalInformation.selectIdentityDocumentDrivingHistoryCertificate',
      [IdDocType.DrivingHistoryCertificateTo]: 'topPersonalInformation.selectIdentityDocumentDrivingHistoryCertificate',
      [IdDocType.DrivingHistoryCertificateTi]: 'topPersonalInformation.selectIdentityDocumentDrivingHistoryCertificate',
      [IdDocType.HealthInsuranceCardTo]: 'topPersonalInformation.selectIdentityDocumentHealthInsuranceCard',
      [IdDocType.HealthInsuranceCardTi]: 'topPersonalInformation.selectIdentityDocumentHealthInsuranceCard',
      [IdDocType.PhysicalDisabilityCertificateBookTo]:
        'topPersonalInformation.selectIdentityDocumentPhysicalDisabilityCertificateBook',
      [IdDocType.PhysicalDisabilityCertificateBookTi]:
        'topPersonalInformation.selectIdentityDocumentPhysicalDisabilityCertificateBook',
      [IdDocType.PhysicalDisabilityCertificateCardTo]:
        'topPersonalInformation.selectIdentityDocumentPhysicalDisabilityCertificateCard',
      [IdDocType.PhysicalDisabilityCertificateCardTi]:
        'topPersonalInformation.selectIdentityDocumentPhysicalDisabilityCertificateCard',
      [IdDocType.SpecialEducationBookTo]: 'topPersonalInformation.selectIdentityDocumentSpecialEducationBook',
      [IdDocType.SpecialEducationBookTi]: 'topPersonalInformation.selectIdentityDocumentSpecialEducationBook',
      [IdDocType.SpecialEducationCardTo]: 'topPersonalInformation.selectIdentityDocumentSpecialEducationCard',
      [IdDocType.SpecialEducationCardTi]: 'topPersonalInformation.selectIdentityDocumentSpecialEducationCard',
      [IdDocType.StudentNotebookTo]: 'topPersonalInformation.selectIdentityDocumentStudentNotebook',
      [IdDocType.StudentNotebookTi]: 'topPersonalInformation.selectIdentityDocumentStudentNotebook',
      [IdDocType.MentalDisabilityCertificateBookTo]:
        'topPersonalInformation.selectIdentityDocumentMentalDisabilityCertificateBook',
      [IdDocType.MentalDisabilityCertificateBookTi]:
        'topPersonalInformation.selectIdentityDocumentMentalDisabilityCertificateBook',
      [IdDocType.MentalDisabilityCertificateCardTo]:
        'topPersonalInformation.selectIdentityDocumentMentalDisabilityCertificateCard',
      [IdDocType.MentalDisabilityCertificateCardTi]:
        'topPersonalInformation.selectIdentityDocumentMentalDisabilityCertificateCard',
      [IdDocType.PensionBookTo]: 'topPersonalInformation.selectIdentityDocumentPensionBook',
      [IdDocType.PensionBookTi]: 'topPersonalInformation.selectIdentityDocumentPensionBook',
      [IdDocType.BasicPensionNumberNotificationTo]:
        'topPersonalInformation.selectIdentityDocumentBasicPensionNumberNotification',
      [IdDocType.BasicPensionNumberNotificationTi]:
        'topPersonalInformation.selectIdentityDocumentBasicPensionNumberNotification',
      [IdDocType.PassportAnyIssuanceDateTo]: 'topPersonalInformation.selectIdentityDocumentPassportAnyIssuanceDate',
      [IdDocType.PassportAnyIssuanceDateTi]: 'topPersonalInformation.selectIdentityDocumentPassportAnyIssuanceDate',
      [IdDocType.BasicResidentRegistrationCardTo]:
        'topPersonalInformation.selectIdentityDocumentBasicResidentRegistrationCard',
      [IdDocType.BasicResidentRegistrationCardTi]:
        'topPersonalInformation.selectIdentityDocumentBasicResidentRegistrationCard',
      [IdDocType.StudentIDCardTo]: 'topPersonalInformation.selectIdentityDocumentStudentIDCard',
      [IdDocType.StudentIDCardTi]: 'topPersonalInformation.selectIdentityDocumentStudentIDCard',
      [IdDocType.MnGeneral]: 'topPersonalInformation.selectIdentityDocumentMnGeneral',
      [IdDocType.GpGeneral]: 'topPersonalInformation.selectIdentityDocumentGpGeneral',
      [IdDocType.DriversLicenseGlobalNoFace]: 'topPersonalInformation.selectIdentityDocumentDriversLicense',
      [IdDocType.NationalIdentityCardGlobalNoFace]: 'topPersonalInformation.selectIdentityDocumentNationalIdentityCard',
      [IdDocType.ResidenceCardGlobalNoFace]: 'topPersonalInformation.selectIdentityDocumentResidenceCard',
      [IdDocType.PassportGlobalNoFace]: 'topPersonalInformation.selectIdentityDocumentPassportGlobal',
      [IdDocType.DriversLicenseGlobalFace]: 'topPersonalInformation.selectIdentityDocumentDriversLicense',
      [IdDocType.NationalIdentityCardGlobalFace]: 'topPersonalInformation.selectIdentityDocumentNationalIdentityCard',
      [IdDocType.ResidenceCardGlobalFace]: 'topPersonalInformation.selectIdentityDocumentResidenceCard',
      [IdDocType.PassportGlobalFace]: 'topPersonalInformation.selectIdentityDocumentPassportGlobal',
      [IdDocType.PhilIDGlobalFace]: 'topPersonalInformation.selectIdentityDocumentPhilid',
      [IdDocType.TINIDGlobalFace]: 'topPersonalInformation.selectIdentityDocumentTinid',
      [IdDocType.SSSIDGlobalFace]: 'topPersonalInformation.selectIdentityDocumentSssid',
      [IdDocType.UMIDGlobalFace]: 'topPersonalInformation.selectIdentityDocumentUmid',
      [IdDocType.UMID2GlobalFace]: 'topPersonalInformation.selectIdentityDocumentUmid2',
      [IdDocType.Unknown]: 'topPersonalInformation.selectIdentityDocumentUnknown'
    };

    return idDocTypes.map(idDocType => ({
      key: idDocType,
      text: this.$t(selectorTexts[idDocType]) as string
    }));
  }

  private get selectMnDocList(): {
    key: MnDocType;
    text: string;
  }[] {
    // 個人番号確認書類はPCに対応していないので、PCだと選択できないようにする
    if (this.$store.getters['camera/isPC']) return [];
    if (!this.$store.getters['auth/isCollectMnDoc']) return [];

    const selectorTexts: { [key in MnDocType]: string } = {
      [MnDocType.MyNumberCard]: 'topPersonalInformation.selectMyNumberDocumentMyNumberCard',
      [MnDocType.NotificationCard]: 'topPersonalInformation.selectMyNumberDocumentNotificationCard',
      [MnDocType.ResidenceCertificate]: 'topPersonalInformation.selectMyNumberDocumentResidenceCertificate',
      [MnDocType.Unknown]: 'topPersonalInformation.selectMyNumberDocumentUnknown'
    };

    const mnDocTypes: MnDocType[] = this.$store.getters['auth/myNumberDocTypes'];
    return mnDocTypes.map(mnDocType => ({
      key: mnDocType,
      text: this.$t(selectorTexts[mnDocType]) as string
    }));
  }

  private get selectGpDocList(): {
    key: string;
    page: number;
    text1: string;
    text2: string;
    text3: string;
    srcset: string[] | null;
  }[] {
    if (!this.$store.getters['auth/isCollectGpDoc']) return [];

    const key: string = 'topPersonalInformation.generalPurposeDocumentMaximumNumberOfPhotos';
    const locale: string = this.$store.getters['i18n/locale'];
    let generalDocs: GeneralDoc[] = this.$store.getters['auth/generalDocs'];
    generalDocs = Array.from(generalDocs).sort((a, b): number => a.displayPriority - b.displayPriority);
    return generalDocs.map(generalDoc => ({
      key: generalDoc.generalDocType,
      page: generalDoc.maxPages,
      text1: generalDoc.generalDocName[locale],
      text2: this.$t(key, { num: generalDoc.maxPages }) as string,
      text3: generalDoc.description[locale],
      srcset: null
    }));
  }

  private get selectOpDocList(): {
    key: string;
    seqNo: number;
    page: number;
    text1: string;
    text2: string;
    text3: string;
  }[][] {
    const locale: string = this.$store.getters['i18n/locale'];
    let optionalDocs: OptionalDocs[] = this.$store.getters['auth/optionalDocs'];
    optionalDocs = Array.from(optionalDocs).sort((a, b): number => a.seqNo - b.seqNo);
    return optionalDocs.map(valueOuter => {
      const sorted = Array.from(valueOuter.selection).sort((a, b): number => a.displayPriority - b.displayPriority);
      return sorted.map(valueInner => ({
        key: valueInner.optionalDocType,
        seqNo: valueOuter.seqNo,
        page: valueInner.maxPages,
        text1: valueInner.optionalDocName[locale],
        text2: '',
        text3: valueInner.description[locale]
      }));
    });
  }

  // 初期化処理
  private async created() {
    // 本人確認書類のデフォルトの選択
    const currentIdDocType: IdDocType = this.$store.getters['camera/idDocType'];
    if (currentIdDocType !== IdDocType.Unknown) {
      this.idDocTypeId = currentIdDocType;
    } else if (this.selectIdDocList.length > 0) {
      this.idDocTypeId = this.selectIdDocList[0].key;
    }

    // 個人番号確認書類のデフォルトの選択
    const currentMnDocType: MnDocType = this.$store.getters['camera/mnDocType'];
    if (currentMnDocType !== MnDocType.Unknown) {
      this.mnDocTypeId = currentMnDocType;
    } else if (this.selectMnDocList.length > 0) {
      this.mnDocTypeId = this.selectMnDocList[0].key;
    }

    // 汎用書類のデフォルトの選択
    const currentGpDocType: string = this.$store.getters['camera/gpDocType'];
    if (currentGpDocType !== 'unknown') {
      this.gpDocTypeId = currentGpDocType;
    } else if (this.selectGpDocList.length > 0) {
      this.gpDocTypeId = this.selectGpDocList[0].key;
    }

    // 補助書類のデフォルトの選択
    const currentOpDocType: string[] = this.$store.getters['camera/opDocType'];
    if (currentOpDocType.length > 0) {
      this.opDocTypeId = currentOpDocType;
    } else if (this.selectOpDocList.length > 0) {
      this.opDocTypeId = this.selectOpDocList.map(value => value[0].key);
    }

    if (this.checkKYCRequestInformation) {
      this.isFirstLoading = true;
      const kycRequestId: number = this.$store.getters['auth/kycRequestID'];

      try {
        const response = await PersonalInformationApi.fetch(kycRequestId);
        this.firstName = response.data.firstName;
        this.middleName = response.data.middleName;
        this.lastName = response.data.lastName;
        this.birthDay = response.data.birthday;
        this.zipCode = response.data.zipCode;
        this.maskedAddress1 = response.data.maskedAddress1;
        this.maskedAddress2 = response.data.maskedAddress2;
        this.maskedAddress3 = response.data.maskedAddress3;
        this.maskedAddress4 = response.data.maskedAddress4;
      } catch (error) {
        if (error instanceof ApiCancelError) {
          // キャンセルは握りつぶす
        } else if (error instanceof ApiModalError) {
          // clientRetryableで処理したエラーは握りつぶす
        } else throw error;
      } finally {
        this.isFirstLoading = false;
      }
    } else {
      this.isFirstLoading = true;
      await new Promise(resolve => window.setTimeout(resolve, 100));
      this.isFirstLoading = false;
    }
  }

  // 次のページへ行く
  private async next(): Promise<void> {
    const kycOrgConfig: KycOrgConfig = this.$store.getters['auth/kycOrgConfig'];

    try {
      this.isLastLoading = true;
      const kycRequestId: number = this.$store.getters['auth/kycRequestID'];
      const isFetchClientTypes: boolean = kycOrgConfig.enableClientTypePC;
      const isFetchMnDocTypes: boolean = this.$store.getters['auth/isCollectMnDoc'];
      const isFetchGpDocTypes: boolean = this.$store.getters['auth/isCollectGpDoc'];
      const isDetectableIdDoc: boolean = kycOrgConfig.autoShootIDDocTypes.indexOf(this.idDocTypeId) >= 0;
      if (isFetchClientTypes) await KycRequests.fetchClientTypes(kycRequestId, this.$store.getters['camera/isPC']);
      await KycRequests.fetchIdDocTypes(kycRequestId, { idDocType: this.idDocTypeId });
      if (isFetchMnDocTypes) await KycRequests.fetchMnDocTypes(kycRequestId, { myNumberDocType: this.mnDocTypeId });
      if (isFetchGpDocTypes) await KycRequests.fetchGpDocTypes(kycRequestId, { generalDocType: this.gpDocTypeId });
      const gpDocPage: number = this.selectGpDocList.find(data => data.key === this.gpDocTypeId)?.page || 0;
      this.sendIdDocTypeIDForGA();
      this.$store.commit('camera/setIdDocType', this.idDocTypeId);
      this.$store.commit('camera/setMnDocType', this.mnDocTypeId);
      this.$store.commit('camera/setGpDocType', this.gpDocTypeId);
      this.$store.commit('camera/setGpDocPageLast', gpDocPage);
      this.$store.commit('camera/setOpDocType', this.opDocTypeId);
      this.$store.commit('camera/isDetectableIdDoc', isDetectableIdDoc);
      this.$store.commit('camera/isDetectStop', false);
      this.$store.commit('camera/resetRetryCount');
      this.$router.push(this.$store.getters['camera/locationFirst']);
    } catch (error) {
      if (error instanceof ApiCancelError) {
        // キャンセルは握りつぶす
      } else if (error instanceof ApiModalError) {
        // clientRetryableで処理したエラーは握りつぶす
      } else throw error;
    } finally {
      this.isLastLoading = false;
    }
  }

  private sendIdDocTypeIDForGA(): void {
    if (this.isFirstLoading || !this.$gtag) return;
    try {
      const sendDateTimeKey: string = moment
        .utc()
        .tz('Asia/Tokyo')
        .format('YYYY-MM-DD HH:mm:ss');

      this.$gtag.event('select_id_doc_type', {
        send_datetime: sendDateTimeKey,
        id_doc_type: this.idDocTypeId
      });
    } catch (_) {
    } finally {
      return;
    }
  }
}
